module.exports = __webpack_public_path__ + "media/MyAudio_9.3902348c.mp3";